export class OverreadFeedbackStatusChange {
  chaseId: number;
  chaseOverreadFeedbackId: number;
  codingReceiptStatus: string;
  commentText: string;
  correctDataset: string;
  qaReceiptStatus: string;
  overreadFeedbackStatus: string;

  constructor(options: Partial<OverreadFeedbackStatusChange>) {
    this.chaseId = options.chaseId;
    this.chaseOverreadFeedbackId = options.chaseOverreadFeedbackId;
    this.codingReceiptStatus = options.codingReceiptStatus;
    this.commentText = options.commentText;
    this.correctDataset = options.correctDataset;
    this.qaReceiptStatus = options.qaReceiptStatus;
    this.overreadFeedbackStatus = options.overreadFeedbackStatus;
  }
}
